import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { Stack } from '@bingads-webui-react/fabric-control';
import {
  TextTitle,
  ValidatedPanel,
  getPanelErrorProps,
} from '@bingads-webui-campaign/wizard-jumbo-card';
import { ServerValidatedWebExclusions, webExclusionPropertyVal } from './server-validated-web-exclusions';
import { getSummary } from '../util/web-exclusions.util';
import image from './media/website-exclusion.svg';

export const WebExclusionsSection = ({
  showSiteExclusion, showIPExclusion, level, exclusionData, setExclusionsCallback, errors, expand, ...rest
}) => {
  const i18n = useContext(I18nContext);

  return (
    <ValidatedPanel
      key="web-exclusions"
      title={<TextTitle
        titleKey={_TL_('Exclusions')}
        icon={image}
        iconStyles={{ width: 22 }}
        topicKey="pop_BA_Settings_Exclusions"
        details={getSummary(level, exclusionData, i18n)}
      />}
      attentionBeaconProps={{ getExtraProps: getPanelErrorProps }}
      actuationProps={{
        expand,
        expandKey: 'web-exclusions',
      }}
      {...rest}
    >
      <Stack tokens={{ childrenGap: 24 }}>
        <span className="web-exclusions-description">
          {i18n.getString(_TL_('Which websites should not show your ads and which IP addresses should be blocked from seeing your ads?'))}
        </span>
        <ServerValidatedWebExclusions
          showSiteExclusion={showSiteExclusion}
          showIPExclusion={showIPExclusion}
          level={level}
          exclusionData={exclusionData}
          setExclusionsCallback={setExclusionsCallback}
          errors={errors}
          formErrorProps={{ filter: webExclusionPropertyVal }}
        />
      </Stack>
    </ValidatedPanel>
  );
};

WebExclusionsSection.propTypes = {
  showSiteExclusion: PropTypes.bool,
  showIPExclusion: PropTypes.bool,
  level: PropTypes.string.isRequired,
  exclusionData: PropTypes.shape({}).isRequired,
  setExclusionsCallback: PropTypes.func.isRequired,
  errors: PropTypes.shape([]),
  expand: PropTypes.func.isRequired,
};

WebExclusionsSection.defaultProps = {
  showSiteExclusion: false,
  showIPExclusion: false,
  errors: [],
};
